import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import * as MDICONS from '@material-ui/icons';
import * as ROUTES from '../../../../constants/routes';
import CreateProjectForm from './CreateProjectForm';

const HelpButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: transparent;
        background-color: transparent;
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.themeColor};
            text-decoration: underline;
        }

        &:active {
            color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

const CreateProjectPage = (props) => {
    const { themeColors, dashboardSidebarSize, userData } = props;
    return (
        <div className="container-fluid">
            <div className="" style={{ marginLeft: dashboardSidebarSize, marginTop: '80px' }}>
                {/* MAIN CARD */}
                <div className="card">
                    {/* HEADER */}
                    <h5 className="card-header">
                        <div className="d-flex justify-content-between">
                            {/* LEFT SIDE HEADER ITEMS */}
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <MDICONS.DashboardRounded className="mr-3" style={{ width: "40px", height: "40px" }} />
                                    <span style={{ fontWeight: "bold" }}>Create a new project</span>
                                </div>
                            </div>
                        </div>
                        {/* RIGHT SIDE HEADER ITEMS */}
                        <div className="d-flex justify-content-end">
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    <div className="d-flex flex-column">
                                        <div className="align-self-between">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </h5>

                    {/* BODY */}
                    <div className="card-body">
                        <CreateProjectForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
    }
}

export default connect(mapStateToProps)(CreateProjectPage);
